import * as Constants from '@/constants'

export const isFuelMonitorV2 = apparatus => {
  if (!apparatus) {
    return false
  }

  if (apparatus.deviceType) {
    return apparatus.deviceType === Constants.TankUtilityLteDeviceTypeV2
  }

  // trying to account for as many different apparatus detail structures/types as possible
  const deviceType =
    apparatus.properties?.find(x => x.type === Constants.ApparatusPropertyDevice)?.value?.deviceType ??
    apparatus.devices?.[0]?.deviceType

  if (!deviceType) {
    return false
  }

  return deviceType === Constants.TankUtilityLteDeviceTypeV2
}
